import React, { useState } from "react";

const HeaderTab = ({updateReviewTabData,reviewTabData}) => {
    const [showHeaderSourceIcon, setHeaderShowSourceIcon] = useState(Number(reviewTabData.header_source_icon));
    const [showHeaderRating, setHeaderShowRating] = useState(Number(reviewTabData.header_rating));
    const [showHeaderNumberReviews, setHeaderShowNumberReviews] = useState(Number(reviewTabData.header_number_of_reviews));
    const [showHeaderWriteReview, setHeaderShowWriteReview] = useState(Number(reviewTabData.header_write_reviews_button));
    const [isHeaderShow, setIsHeaderShow] = useState(Number(reviewTabData.header_is_show_header));
    const [isWidgetTitleShow, setIsWidgetTitleShow] = useState(Number(reviewTabData.header_is_widget_title));

    // Default values for the reviewTabData
    const {
        header_title,
        header_caption,
    } = reviewTabData || {};

    //Handle Show Header toggle
    const handleIsHeaderShowToggle = (e) => {
        const checked = e.target.checked;
        setIsHeaderShow(checked);
        updateReviewTabData('header_is_show_header', checked);
    };

    //Handle Show Widget Title toggle
    const handleIsWidgetTitleToggle = (e) => {
        const checked = e.target.checked;
        setIsWidgetTitleShow(checked);
        updateReviewTabData('header_is_widget_title', checked);
    };

    // Handlers (receiving the event)
    const handleHeaderSourceIconChange = (e) => {
        const checked = e.target.checked;
        setHeaderShowSourceIcon(checked);
        updateReviewTabData("header_source_icon", checked); 
    };

    //Handle header rating on Change
    const handleHeaderShowRatingChange = (e) => {
        const checked = e.target.checked;
        setHeaderShowRating(checked);
        updateReviewTabData("header_rating", checked); 
    };

    //Handle header number review on Change
    const handleHeaderNumberReviewsChange = (e) => {
        const checked = e.target.checked;
        setHeaderShowNumberReviews(checked);
        updateReviewTabData("header_number_of_reviews", checked); 
    };

    //Handle header Write review on Change
    const handleHeaderWriteReviewChange = (e) => {
        const checked = e.target.checked;
        setHeaderShowWriteReview(checked);
        updateReviewTabData("header_write_reviews_button", checked); 
    };

    return (
        <div className="side-baar-inner-header">
            <span>Header</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Show header</span>
                    <div className="form-group">
                        <input
                            type="checkbox"
                            id="header_show_header_toggle"
                            className="chkbx-toggle"
                            checked={isHeaderShow}
                            onChange={handleIsHeaderShowToggle}
                        />
                        <label htmlFor="header_show_header_toggle"></label>
                    </div>
                </div>

                {/* Show Header Elements */}
                {isHeaderShow && (
                <>
                <div className="box-header-row">
                    <span>Elements</span>
                    <ul>
                        <li>
                            <div className="form-group">
                                <input type="checkbox" id="sourceIcon" checked={showHeaderSourceIcon} onChange={handleHeaderSourceIconChange} /> 
                                <label for="sourceIcon">Heading</label>
                            </div>
                        </li>
                        <li>
                            <div className="form-group">
                                <input type="checkbox" id="rating" checked={showHeaderRating} onChange={handleHeaderShowRatingChange} />
                                <label for="rating">Rating</label>
                            </div>
                        </li>
                        <li>
                            <div className="form-group">
                                <input type="checkbox" id="numberReviews" checked={showHeaderNumberReviews} onChange={handleHeaderNumberReviewsChange} />
                                <label for="numberReviews">Number of Reviews</label>
                            </div>
                        </li>
                        <li>
                            <div className="form-group">
                                <input type="checkbox" id="writeReview" checked={showHeaderWriteReview} onChange={handleHeaderWriteReviewChange} />
                                <label for="writeReview">Write a Review Button</label>
                            </div>
                        </li>
                    </ul>
                </div>
                </>
                )}
            </div>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Widget Title</span>
                    <div className="form-group">
                        <input
                            type="checkbox"
                            id="is_show_widget_title_toggle"
                            className="chkbx-toggle"
                            checked={isWidgetTitleShow}
                            onChange={handleIsWidgetTitleToggle}
                        />
                        <label htmlFor="is_show_widget_title_toggle"></label>
                    </div>
                </div>
                {/* Show Widget Title */}
                {isWidgetTitleShow && (
                    <>
                        <div className="box-header-row">
                            <h6>Title</h6>
                            <input type="text" value={header_title || ""} placeholder={header_title || ""} onChange={(e) => updateReviewTabData('header_title', e.target.value)} className="title-text" />
                        </div>
                        <div className="box-header-row">
                            <textarea id="editor" placeholder="Caption..." value={header_caption || ""} onChange={(e) => updateReviewTabData('header_caption', e.target.value)}></textarea>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default HeaderTab;